export default __webpack_public_path__ + "static/wireframes-6415d66c0f43f3f6f479b5b668ddd31c.svg";